<template>
  <div>
    <Title
      title="智慧管理"
      subTitle="Intelligent Management"
      @showMore="showMore"
    ></Title>
    <!-- 数字 -->
    <div class="count-con">
      <div class="count-item">
        <div class="left-icon">
          <div></div>
        </div>
        <div class="content">
          <div class="title">服务人员</div>
          <div class="count">
            <!-- <p>{{ manageData.serviceNum }}</p> -->
            <p>295</p>
            <span>人</span>
          </div>
        </div>
      </div>
      <div class="count-item">
        <div class="left-icon">
          <div></div>
        </div>
        <div class="content">
          <div class="title">服务次数</div>
          <div class="count">
            <p>{{ manageData.serviceTimes }}</p>
            <span>次</span>
          </div>
        </div>
      </div>
      <div class="count-item">
        <div class="left-icon">
          <div></div>
        </div>
        <div class="content">
          <div class="title">人员配比</div>
          <div class="count">
            <!-- <p>{{ manageData.serviceRatio }}</p> -->
            <p>4.1</p>
            <span>: 1</span>
          </div>
        </div>
      </div>
      <div class="count-item">
        <div class="left-icon">
          <div></div>
        </div>
        <div class="content">
          <div class="title">智能设备</div>
          <div class="count" v-if="manageData.equipmentNum">
            <p>{{ formatter(manageData.equipmentNum) }}</p>
            <span>台</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 图表 -->
    <div class="charts-con">
      <div class="chart-item">
        <div class="chart-title">老人年龄分布</div>
        <div id="age-chart"></div>
        <div class="chart-desc">
          照护计划完成率 <span>{{ manageData.takeCarePlanFin }}</span
          >%
        </div>
        <div class="chart-desc">
          累计捐赠资金 <span>{{ formatter(manageData.donateMoney) }}</span>
        </div>
      </div>
      <div class="chart-item">
        <div class="chart-title">护理员技术水平比例</div>
        <div id="level-chart"></div>
        <div class="chart-desc">
          安全评估人次 <span>{{ manageData.evaluateTimes }}</span> 次
        </div>
        <div class="chart-desc">
          库房总数量 <span>{{ formatter(manageData.stockNum) }}</span> 个
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Commen/Title";
const echarts = require("echarts");
import roseChart from "./charts/rosePie";
import { mapState, mapActions } from "vuex";
import pollingFunction from "@/utils/tools";
export default {
  components: {
    Title,
  },
  data() {
    return {
      pollingST: null,
      serviceNum: {
        number: [16],
        content: "{nt}",
      },
      age_data: [],
    };
  },
  computed: {
    ...mapState(["manageData"]),
  },
  created() {},
  async mounted() {
    //调用轮询;
    if (!this.pollingST) {
      setTimeout(() => {
        this.pollingST = pollingFunction(this.getData, 3000);
      }, 3000);
    }
    await this.getData();
  },
  methods: {
    ...mapActions(["getManageData"]),
    async getData() {
      await this.getManageData({});
      // 年龄分布
      const age_data = this.manageData.elderAgeMap;
      let age_arr = [];
      Object.keys(age_data).forEach((item) => {
        let obj = {};
        obj["name"] = item;
        obj["value"] = age_data[item];
        age_arr.push(obj);
      });
      this.age_data = age_arr;
      // 护理员技术水平比例
      this.drawChart();
    },
    showMore() {
      this.$store.commit("setDrawer", true);
      this.$store.commit("setCurrentMenu", "manage");
    },
    drawChart() {
      this.ageChart = echarts.init(document.getElementById("age-chart"));
      this.ageChart.setOption(roseChart(this.age_data));
      this.levelChart = echarts.init(document.getElementById("level-chart"));
      this.levelChart.setOption(
        roseChart([
          { value: 330, name: "技师" },
          { value: 250, name: "初级" },
          { value: 200, name: "中级" },
          { value: 150, name: "高级" },
        ])
      );
      // this.alarmChart = Highcharts.chart(
      //   "alarm-chart",
      //   AlarmChart(this.alarmTotal.rows)
      // );
    },
    formatter(number = 0) {
      const numbers = number.toString().split("").reverse();
      const segs = [];

      while (numbers.length) segs.push(numbers.splice(0, 3).join(""));

      return segs.join(",").split("").reverse().join("");
    },
  },
  destroyed() {
    clearTimeout(this.pollingST);
  },
};
</script>

<style lang="scss" scoped>
.count-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 450px;
  margin-top: 10px;
  .count-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .left-icon {
    position: relative;
    width: 9px;
    height: 38px;
    transform: rotate(0deg);
    opacity: 1;
    pointer-events: none;
    border: 1px solid rgb(0, 139, 255);
    background-color: rgba(0, 58, 140, 0.1);
    border-radius: 8px;
    div {
      position: absolute;
      width: 7px;
      height: 22px;
      transform: rotate(0deg);
      opacity: 1;
      pointer-events: none;
      left: 1px;
      top: 15px;
      background-color: rgb(0, 255, 232);
      opacity: 1;
      border-radius: 8px;
    }
  }
  .content {
    display: flex;
    align-items: flex-start;
    justify-items: center;
    flex-direction: column;
    margin-left: 10px;
    .title {
      color: rgb(121, 218, 255);
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: normal;
      margin: 0px 0px 1.75px;
      justify-content: flex-start;
    }
    .count {
      display: flex;
      align-items: baseline;
      font-size: 27px;
      font-weight: bolder;
      letter-spacing: 0.02em;
      color: #fff;
      p {
        margin: 0;
      }
      span {
        color: #fff;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.74);
        font-weight: normal;
        vertical-align: super;
        font-family: Microsoft Yahei;
        margin-left: 2px;
      }
    }
  }
}
.charts-con {
  width: 450px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  .chart-item {
    width: 50%;
    .chart-title {
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 16px;
      writing-mode: horizontal-tb;
      text-overflow: unset;
      white-space: unset;
      color: rgb(255, 255, 255);
    }
    #age-chart {
      position: relative;
      z-index: 999;
      width: 200px;
      height: 160px;
    }
    #level-chart {
      position: relative;
      z-index: 999;
      width: 200px;
      height: 160px;
    }
    .chart-desc {
      color: rgb(222, 246, 255);
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 18px;
      span {
        font-size: 18px;
        color: rgb(238, 255, 5);
        font-family: DIN;
      }
    }
  }
}
</style>
